<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';
  import { getJoodMembershipBasedPropertyValue, isMobileWidth } from '../../../common/util';
  import { getDataFromAmplienceAsync } from '../../common/services/amplience';

  export let metaData;

  const { lang } = getAppConfig();
  const isResponsive = isMobileWidth();

  const BG = {
    en: {
      desktop: `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}safeguardbannerENDesktop?fmt=auto`,
      mobile: `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}safeguard_banner_d-en?fmt=auto`,
    },
    ar: {
      desktop: `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}safeguardbannerARDesktop?fmt=auto`,
      mobile: `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}safeguard_banner_d-ar?fmt=auto`,
    },
  };

  const locale = lang === 'ar' ? 'ar' : 'en';
  let backgroundImage = isResponsive ? BG[locale].mobile : BG[locale].desktop;

  let htmlContent: string | null = null;
  let loaded = false;

  async function loadBanner() {
    loaded = false;
    htmlContent = null;

    try {
      const amplienceId = getJoodMembershipBasedPropertyValue(
        metaData,
        'amplienceId',
        'blueAmplienceId',
        'goldAmplienceId'
      );

      if (!amplienceId) return;

      const response = await getDataFromAmplienceAsync(amplienceId);

      const body = response['body'] || response;

      htmlContent = lang === 'ar' ? body?.webServicesAR : body?.webServicesEN;

      loaded = !!htmlContent;
    } catch (error) {
      console.error('[HM Banner] Load failed:', error);
      loaded = false;
    }
  }

  export async function onLoad() {
    await loadBanner();
  }
</script>

{#if loaded && htmlContent}
  <section class="hm-safeguard" style="background-image: url('{backgroundImage}');">
    <div class="hm-banner-wrapper">
      {@html htmlContent}
    </div>
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .hm-banner-wrapper {
    width: 100%;
  }

  :global {
    .hm-safeguard {
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      min-height: 680px;
      max-width: 1320px;
      margin: 0 auto;
      display: flex;

      @include responsive {
        min-height: 473px;
        align-items: flex-start;
        border-radius: 24px;
      }
      .hm-content-bottom {
        position: absolute;
        left: 440px;
        bottom: 272px;

        @include responsive {
          left: 256px;
          bottom: 336px;
        }
        .c_app-push-block {
          background: transparent;
          .app-button {
            flex-direction: row;
            gap: 4px;
            img {
              width: 72px;
              @include responsive {
                width: 36px;
              }
            }
          }
        }
      }
    }

    .hm-overlay {
      width: 40%;
      @include responsive {
        width: 95%;
      }
      .hm-content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        @include responsive {
          gap: 16px;
        }
        &-top {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        &-bottom {
          display: flex;
          flex-direction: column;
          gap: 32px;
          @include responsive {
            gap: 16px;
          }
        }
      }
    }

    .hm-title {
      font-size: 30px;
      font-weight: 700;
      line-height: 37px;
      display: flex;
      flex-direction: column;
      color: #382f2d;
      @include responsive {
        font-size: 20px;
        line-height: 27px;
        gap: 0;
      }
    }

    .hm-subtitle {
      font-size: 16px;
      color: #382f2d;
      margin: 0;
      @include responsive {
        font-size: 14px;
      }
    }

    .hm-cta {
      display: inline-block;
      background: #f28b2e;
      color: $primary-white !important;
      padding: 18px 36px;
      border-radius: 100px;
      font-weight: 700;
      border: none;
      cursor: pointer;
      width: fit-content;
      text-align: center;
      font-size: 24px;
      line-height: 28px;

      @include responsive {
        font-size: 13px;
        line-height: 18px;
        padding: 8px 16px;
      }
    }

    .hm-plan {
      display: flex;
      align-items: flex-start;
      gap: 24px;
      @include responsive {
        gap: 12px;
      }
      .hm-plan-icon {
        height: 66px;
        width: 66px;
        @include responsive {
          height: 40px;
          width: 40px;
        }
      }
    }
    .hm-plan-text-wrapper {
      display: flex;
      flex-direction: column;
      gap: 12px;
      @include responsive {
        gap: 8px;
      }
      .hm-plan-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 26px;
        margin: 0;
        @include responsive {
          font-size: 14px;
          line-height: 10px;
        }
      }

      .hm-plan-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        margin: 0;
        @include responsive {
          font-size: 10px;
          line-height: 12px;
        }
      }
    }

    .c_app-push-block {
      background-color: transparent;
      padding: 0;
      .app-button-container {
        @include responsive {
          margin: 0;
          max-width: 100%;
        }
      }
      .app-button {
        @include responsive {
          flex-direction: row;
        }
      }
    }
  }
</style>
